import { FiSend } from "react-icons/fi"

export function MessageInput({ input, setInput, handleSend }) {
    const canSend = input.trim().length > 0

    return (
        <div className="flex items-center gap-2 border-t border-border bg-card p-3">
            <input
                type="text"
                placeholder="Écris un message..."
                value={input}
                onChange={(e) => setInput(e.target.value)}
                onKeyPress={(e) => e.key === 'Enter' && handleSend()}
                className="input-ios h-10 flex-1 rounded-full border border-input bg-background px-4 text-sm text-foreground placeholder:text-muted-foreground focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/30"
            />
            <button
                onClick={handleSend}
                disabled={!canSend}
                aria-label="Envoyer"
                className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary text-white shadow-sm transition-all hover:bg-primary/90 active:scale-95 disabled:cursor-not-allowed disabled:opacity-40"
            >
                <FiSend className="h-4 w-4" />
            </button>
        </div>
    )
}